<template>
  <action-dispatcher
    class="view-audios container text-light py-5"
    action="podcasts/getAudios"
    ref="audioGetter"
    :parameters="params"
  >
    <h4 class="text-center mb-4">Áudios</h4>
    <div class="row justify-content-center">
      <div v-for="audio in audios" :key="audio.id" class="col-lg-6 py-3">
        <audio-slide :resource="audio" />
      </div>
    </div>
    <div class="d-flex justify-content-center my-3">
      <button
        class="btn btn-secondary btn-strong rounded-pill px-5"
        :disabled="loading"
        @click="loadMore"
      >
        <loading :show="loading">
          Carregar mais
        </loading>
      </button>
    </div>
  </action-dispatcher>
</template>

<script>
import AudioSlide from "@/components/trail/AudioSlide";
import { mapState } from "vuex";

export default {
  components: { AudioSlide },
  data() {
    return {
      loading: false,
      params: {
        offset: 0,
        limit: 10
      }
    };
  },
  computed: {
    ...mapState("podcasts", ["audios"]),
    podcast() {
      return this.audios.find(pod => pod.id == this.$route.params.id) || {};
    }
  },
  methods: {
    src(audio) {
      if (audio.link.indexOf("player") > 0) {
        return audio.link;
      }
      return `https://w.soundcloud.com/player/?url=${audio.link}`;
    },
    iframeHeight(audio) {
      if (audio.link.indexOf("playlists") > 0) {
        return 450;
      }
      return 170;
    },
    loadMore() {
      this.params.offset += this.params.limit;
      this.loading = true;
      setTimeout(() => {
        this.$store.dispatch("podcasts/getAudios", this.params).finally(() => {
          this.loading = false;
        });
      }, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-audios {
  .description {
    font-size: 14px;
    color: #d7d7d7;
  }
}
</style>
